/* istanbul ignore file */

export const FORM_FIELDS = {
  SEARCH_TERM: 'searchTerm',
  SEARCH_TAGS_TERM: 'searchTagsTerm',
  SEARCH_TAGS: 'searchTags',
  SELECT_ALL: 'selectAll',
  SHOW_ARTICLE_READY_ONLY: 'showArticleReadyOnly',
  THREE_BY_ONE_FILTER: 'threeByOneFilter',
};
